import React from 'react'
import { ListFilter as Header } from '../../../components'
import { sorter } from '../../../utils'
import { PaginationAddOn } from './pagination-add-on'
// import { useHistory, useLocation } from 'react-router-dom'
// import qs from 'query-string'

const CollectionList = ({
  children,

  // Sorter Props
  data,
  setData,
  sortOptions = [],
  setSorter = () => {},

  // Filters Props
  query = {},
  setStatus = () => {},

  // Pagination Nav Props
  itemsPerPage = 0,
  setPageItems,
  totalData = 0,

  // Pagination Nav Props - Redux
  setCurrentPage = () => {},
  defaultCurrentPage = 1,

  // Pagination API Props
  withPaginationAPI,
}) => {
  // const history = useHistory()
  // const location = useLocation()
  const [pageIndexes, setPageIndexes] = React.useState([0, itemsPerPage])

  const handleSort = ({value, key}) => {
    if(withPaginationAPI){
      setSorter({value, key})
    } else {
      sorter(value, key, data, setData)
    }
  }

  return (
    <div className="collection-list">
      <Header
        pageIndexes={pageIndexes}
        totalData={totalData}
        sortOptions={sortOptions}
        onSort={handleSort}
        query={query}
        setStatus={setStatus}
      />
      <PaginationAddOn

        // Sorter Props
        data={data}
        // Pagination Nav Props
        itemsPerPage={itemsPerPage}
        setPageItems={setPageItems}
        totalData={totalData}

        // Pagination Nav Props - Redux
        setCurrentPage={setCurrentPage}
        defaultCurrentPage={defaultCurrentPage}

        // Pagination API Props
        withPaginationAPI={withPaginationAPI}

        pageIndexes={pageIndexes}
        setPageIndexes={setPageIndexes}
      >
        {children}
      </PaginationAddOn>
    </div>
  )
}

export { CollectionList }
